import React, { useState } from "react";
import { BsPlus } from "react-icons/bs";
import { useGlobalContext } from "context/globalContext";
import CreateOrUpdatePromptFragmentsModal from "../create-or-update-prompt-fragments/createOrUpdatePromptFragmentsModal";
import PreviewPromptFragmentsModal from "../preview-prompt-fragments-modal/previewPromptFragmentsModal";
import { consoleLog } from "helpers";
// import CreateOrUpdateCountriesModal from "../create-or-update-countries/createOrUpdateCountriesModal";
// import FormPopup from "FormModal/FormModal";

function CreatePromptFragments(props) {
  const { transparent } = props;
  const [open, setOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const {
    isOpenPromptFragmentsEditForm,
    setIsOpenPromptFragmentsEditForm,
    isOpenPromptFragmentsPreviewModal = false,
    setIsOpenPromptFragmentsPreviewModal,
  } = useGlobalContext();

  const handleFormOpen = () => {
    setIsFormOpen(true);
  };
  const handleFormClose = () => {
    setIsFormOpen(false);
  };
  const handleFormSubmit = (formData) => {
    consoleLog(["Form submitted:", formData]);
  };

  return (
    <div className="relative">
      <button
        onClick={() => {
          setOpen(!open);
          handleFormOpen();
        }}
        className={`flex items-center text-xl hover:cursor-pointer ${
          transparent
            ? "bg-none text-white hover:bg-none active:bg-none"
            : "bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-gray-10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"
        } linear justify-center rounded-lg font-bold transition duration-200`}
      >
        <BsPlus className="fill-amber-900" />
      </button>
      <CreateOrUpdatePromptFragmentsModal
        isOpen={isFormOpen}
        onClose={handleFormClose}
        onSubmit={handleFormSubmit}
        isEditMode={false}
        // tableData={tableData}
        // getSystemPromptData={getSystemPromptData}
      />
      <CreateOrUpdatePromptFragmentsModal
        isOpen={isOpenPromptFragmentsEditForm}
        onClose={() => setIsOpenPromptFragmentsEditForm(false)}
        onSubmit={handleFormSubmit}
        isEditMode={true}
        // tableData={tableData}
      />
      <PreviewPromptFragmentsModal
        isOpen={isOpenPromptFragmentsPreviewModal}
        onClose={() => setIsOpenPromptFragmentsPreviewModal(false)}
      />
    </div>
  );
}

export default CreatePromptFragments;
